import React from 'react';
import { Vara } from '../../components/vara';
import runstykkilist from '../../resources/runstykki.json';
import './styles.css';

const Runstykki = () => {

  const getImagePath = (imageName) => {
    if (!imageName) return null;
    try {
      return require(`../../resources/runstykki/${imageName}`);
    } catch {
      return null;
    }
  };

  const bannerUrl = require('../../resources/runstykkicover.jpeg');

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <div className="relative h-52 w-full overflow-hidden">
        <img src={bannerUrl} alt="Brauðmeti" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-4xl font-serif text-white mb-2">Brauðmeti</h1>
          <div className="w-12 h-0.5 bg-[#C29979] mb-3"></div>
          <p className="text-white/80 font-serif text-sm">Brauðmetið okkar er bakað nýtt alla morgna.</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 py-10">
        <ul className="flex flex-wrap justify-center">
          {runstykkilist.items.map((item) => {
            const image = getImagePath(item.images);
            if (!image) return null;
            return (
              <Vara
                key={item.id}
                name={item.name}
                image={image}
                description={item.description}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Runstykki;
